import React from "react";
import { PlayIcon } from '@heroicons/react/24/solid'

export const PlayButton: React.FC<React.HTMLProps<HTMLButtonElement>> = ({onClick}: React.HTMLProps<HTMLButtonElement>) => {
  return (

      <button
        className="m-auto w-24 h-24 border-2 border-[#B28B31] shadow-inner bg-transparent hover:border-[#f3ce77] hover:shadow-[inset_0_0_30px_30px_#B28B31] active:scale-100 active:shadow-[inset_0_0_30px_30px_#B28B3199] focus:outline-none rounded-full playButton"
        onClick={onClick}
      >
        <div className="m-auto w-8 h-8">
          <PlayIcon/>
        </div>
      </button>
  );
};
